module.exports = __webpack_public_path__ + "img/52002748_L.7a06ba98.png";